import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiTag, FiCpu, FiShield } = FiIcons;

const Changelog = () => {
  const updates = [
    {
      version: "v1.2.0 - The Venice Update",
      date: "Nov 15, 2024",
      type: "Major Release",
      items: [
        "Integrated Venice v4 Clinical models for high-fidelity triage.",
        "Added .hdpkg packaging format for marketplace distribution.",
        "New 'Agent Mode' for proactive architectural optimization.",
        "Enhanced HIPAA audit logging for all Venice inference calls."
      ],
      icon: FiCpu
    },
    {
      version: "v1.1.5 - Compliance Core",
      date: "Oct 28, 2024",
      type: "Feature Update",
      items: [
        "Launched the Compliance Dashboard with real-time FDA CDS tracking.",
        "Added multi-region jurisdiction support for GDPR/HIPAA compliance.",
        "Improved visual builder performance for complex workflows."
      ],
      icon: FiShield
    }
  ];

  return (
    <div className="pt-24 pb-20 bg-brand-ivory min-h-screen">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-20">
          <h1 className="text-5xl font-display font-bold text-brand-indigo mb-6">Changelog</h1>
          <p className="text-xl text-brand-slate">Stay updated with the latest evolution of the HDAI Clinical IDE.</p>
        </div>

        <div className="space-y-16">
          {updates.map((update, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="relative pl-12 border-l-2 border-gray-200"
            >
              <div className="absolute -left-[17px] top-0 w-8 h-8 bg-brand-indigo rounded-full border-4 border-brand-ivory flex items-center justify-center">
                <SafeIcon icon={update.icon} className="text-brand-mint text-xs" />
              </div>
              <div className="mb-4 flex items-center space-x-4">
                <span className="text-2xl font-bold text-brand-indigo">{update.version}</span>
                <span className="px-3 py-1 bg-brand-mint text-brand-indigo text-[10px] font-bold rounded-full uppercase tracking-widest">{update.type}</span>
              </div>
              <div className="flex items-center space-x-2 text-brand-slate text-sm mb-6">
                <SafeIcon icon={FiCalendar} />
                <span>{update.date}</span>
              </div>
              <ul className="space-y-4">
                {update.items.map((item, j) => (
                  <li key={j} className="flex items-start space-x-3 text-brand-slate leading-relaxed">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand-mint shrink-0"></span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Changelog;